import React, { useState } from "react";
import { api } from "../lib/brand";

export const LeadMagnetForm = ({
  source = "landing",
  ctaLabel = "Send me the gap report",
  helper = "We don't sell anything. We send 5 emails over 7 days, then stop.",
  testIdPrefix = "lead",
  onSuccess,
}) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [state, setState] = useState("idle"); // idle | loading | done | error
  const [errMsg, setErrMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (state === "loading") return;
    if (!email || !email.includes("@")) {
      setErrMsg("Please enter a valid email.");
      setState("error");
      return;
    }
    setState("loading");
    setErrMsg("");
    try {
      await api.post("/leads", { email, name: name || null, source });
      setState("done");
      onSuccess && onSuccess({ email });
    } catch (err) {
      setErrMsg(err?.response?.data?.detail || "Something went wrong. Try again.");
      setState("error");
    }
  };

  if (state === "done") {
    return (
      <div data-testid={`${testIdPrefix}-success`} className="haven-card" style={{ padding: 22 }}>
        <div className="haven-label">Sent</div>
        <h3 className="font-serif" style={{ fontSize: 22, marginTop: 6, color: "var(--ink)" }}>Check your inbox.</h3>
        <p style={{ color: "var(--ink-soft)", fontSize: 14, marginTop: 8 }}>
          The first email is on its way. If it isn't there in two minutes, peek in promotions or spam — and tell us, we'll fix it.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid={`${testIdPrefix}-form`} className="space-y-3">
      <div className="grid sm:grid-cols-2 gap-3">
        <input
          data-testid={`${testIdPrefix}-name-input`}
          className="haven-input"
          placeholder="First name (optional)"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          data-testid={`${testIdPrefix}-email-input`}
          className="haven-input"
          placeholder="Your email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <button
          data-testid={`${testIdPrefix}-submit-btn`}
          type="submit"
          className="haven-btn haven-btn-primary"
          disabled={state === "loading"}
        >
          {state === "loading" ? "Sending…" : ctaLabel}
        </button>
        <span style={{ color: "var(--ink-muted)", fontSize: 12 }}>{helper}</span>
      </div>
      {state === "error" && (
        <div data-testid={`${testIdPrefix}-error`} style={{ color: "var(--rose)", fontSize: 12 }}>
          {errMsg}
        </div>
      )}
    </form>
  );
};

export default LeadMagnetForm;
